import { getType, Reducer } from 'typesafe-actions'

import { withLoadingReducer } from '../../../redux/loading'

import { AccountReportsActions } from './actions'
import { AccountReportsState } from './types'

export const initialState: AccountReportsState = {
  data: [],
  filter: '',
  page: 1,
  totalPages: 1,
  reportDetails: {},
  htmlDocument: {},
  filters: {}
}

export const reducer: Reducer<AccountReportsState, AccountReportsActions> = (
  state = initialState,
  action
): AccountReportsState => {
  switch (action.type) {
    case getType(AccountReportsActions.fetchData): {
      return {
        ...state,
        filter: action.payload.filter,
        page: action.payload.page
      }
    }
    case getType(AccountReportsActions.setData): {
      return {
        ...state,
        data: action.payload.data,
        page: action.payload.page,
        totalPages: action.payload.totalPages
      }
    }
    case getType(AccountReportsActions.setReportDetail): {
      return {
        ...state,
        reportDetails: {
          ...state.reportDetails,
          [action.payload.reportId]: action.payload.report
        }
      }
    }
    case getType(AccountReportsActions.setFilters): {
      return {
        ...state,
        filters: action.payload
      }
    }
    case getType(AccountReportsActions.clearFilter): {
      const filters = { ...state.filters }
      delete filters[action.payload.filterKey]
      return {
        ...state,
        filters: filters
      }
    }
    case getType(AccountReportsActions.setReport): {
      return {
        ...state,
        htmlDocument: action.payload
      }
    }
    case getType(AccountReportsActions.resetReport): {
      return {
        ...state,
        htmlDocument: null
      }
    }
    default:
      return state
  }
}

export const accountReportsReducer = withLoadingReducer(reducer, 'accountReports', initialState)
